import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('ep-file-chip')
export class EPFileChip extends LitElement {

  @property({ attribute: 'file-name', reflect: true })
  fileName?: string;

  @property({ type: Number, attribute: 'file-size', reflect: true })
  fileSize?: number;

  @property({ reflect: true })
  icon: string = '📁';

  @property({ reflect: true })
  href?: string;

  @property({ reflect: true })
  target?: string;

  render() {
    return html`
      <overlay-trigger placement="top" style="font-size: initial;">
        <ep-chip slot="trigger" style="max-width: var(--max-width); font-weight: 500; --filled-background: var(--chip-background);" .href=${this.href} .target=${this.target}>
            <span slot="leading-icon">${this.icon}</span>
            ${this.fileName}
            <slot slot="trailing-icon" name="trailing-icon"></slot>
        </ep-chip>
        <ep-tooltip slot="hover-content" color="light" placement="top" style="--max-width: auto;">
            <span slot="icon">${this.icon}</span>
            <div style="display: flex; flex-direction: column;">
                <span style="font-weight: 500;">
                  ${this.fileName}
                </span>
                <span style="color: #656d76;" >
                  File Size: <ep-file-size size=${this.fileSize ?? 0}></ep-file-size>
                </span>
            </div>
        </ep-tooltip>
      </overlay-trigger>
    `
  }

  static styles = css`
    :host {
      display: inline-block;
      max-width: var(--max-width);
      --max-width: auto;
      --chip-background: rgba(0, 0, 0, 0.08);
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-file-chip': EPFileChip
  }
}
